// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';

import type { TestId } from '@trello/test-ids';

import type { IconSize } from '../src/components/Icon';
import { Icon } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon.
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default token('color.icon', '#42526E')
   */
  color?: string;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-testid) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId | string;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const KeyIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2426 12.1716L10.5858 14.8284L11.2929 15.5355C11.6834 15.9261 11.6834 16.5592 11.2929 16.9497C10.9023 17.3403 10.2692 17.3403 9.87865 16.9497L9.17156 16.2427L7.75734 17.6569L9.17154 19.0711C9.56207 19.4616 9.56207 20.0948 9.17154 20.4853C8.78102 20.8758 8.14785 20.8758 7.75733 20.4853L6.34313 19.0711L5.36592 20.0483C4.9754 20.4388 4.34223 20.4388 3.95171 20.0483C3.56118 19.6578 3.56118 19.0246 3.95171 18.6341L5.63134 16.9544L5.63601 16.9497L5.6407 16.9451L8.4598 14.126L8.46444 14.1213L8.46911 14.1167L11.8284 10.7574L13.2426 12.1716Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5C14.3431 5 13 6.34315 13 8C13 9.65685 14.3431 11 16 11C17.6569 11 19 9.65685 19 8C19 6.34315 17.6569 5 16 5ZM11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const KeyIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId || 'KeyIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={KeyIconGlyph}
    />
  );
};
